import React, { createRef, Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form, Control } from 'react-redux-form';
import { Row, Col, OverlayTrigger, Popover } from 'react-bootstrap';
import Translation from '../../../../.././/common/translation/translation.component';
import { EQUIPMENT_TYPE, TRANSLATIONS as translation, CIRCUIT_TYPES as CircuitTypes } from '../../../../../../utils/constant.utils';
import { ORFButton as Button } from '../../../../../common/forms/order-request-form.component';
import { wirelessPortInActions } from "./../../../../../../store/external/request-reducer/order-request-reducer/wireless-request/wireless-port-in.reducer";
import { ControlCheckBox } from '../../../../../common/custom-form/checkbox.component';
import TableWithButton from '../../../../../common/details-table/table-with-button.component';
import { InputFieldFloatingLabel } from "../../../../../common/custom-form/select-filter.component";
import { MAX_LENGTH } from "../../../../../../constants/external-constants";
import CustomSearchableSelectWrapper from "../../../../../common/custom-form/custom-searchable-select-wrapper.component";
import { Loading } from '../../../../../common/loading/index';
import { withRouter } from 'react-router-dom';
import CustomSearchableDropdownWrapper from '../../../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper';
import { ChatbotActions } from "./../../../../../../store/common/chatbot/chatbot.reducer";
import { httpGet } from '../../../../../../utils/api.utils';

class PortInSubscriptionFormA extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mobileAlreadyExist: false,
            serviceTypeExist: false,
            isDevice: false,
            cachedMobileServiceTypeOptions: [],
            isKyberProcAuthorized:false,
            isKyberProcAuthorizationLoaded:false
        }
    }
    componentDidMount() {
        this.loadKyberProcAuthorization();
    }
    componentDidUpdate(prevProps) {
        const prev = prevProps?.wirelessPortInRequest?.mobileServiceTypeOptions || [];
        const curr = this.props?.wirelessPortInRequest?.mobileServiceTypeOptions || [];

        if (curr !== prev && Array.isArray(curr) && curr.length >= 2) {
            this.setState({ cachedMobileServiceTypeOptions: curr });
        }
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    renderPopover = (title, body) => {
        return (
            <Popover id="comp-popover" title={title} className="plan-comp-popover">
                {body}
            </Popover>
        );
    };

    findOptionValue = (options, key) => {
        if (!options || !Array.isArray(options)) return "";
        const k = key?.toString?.() ?? `${key}`;
        const match = options.find(o => (o?.Key?.toString?.() ?? `${o?.Key}`) === k);
        return match?.Value ?? "";
    };

    openAskAi = async (payload) => {
        if (!this.canUseKyberProcAskAi()) {
            return;
        }
        const entrySource = payload?.entrySource || "plan_link";
        const isDevice = entrySource === "service_type_link";
        const contextType = isDevice ? "device_advisor" : "plan_advisor";
        const startMsg = isDevice ? "DEVICE_ADVISOR_START" : "PLAN_ADVISOR_START";

        await this.props.setContext(contextType, payload, entrySource);
        this.props.toggleChat(true);
        await this.props.sendMessage(startMsg, 0, 0, false, 0, false);
    };

    loadKyberProcAuthorization = async () => {
        try {
            const result =
                await httpGet(
                    'external/kyberconfig/kyber-proc-agent/enabled'
                );

            if (
                result == null ||
                result?.ok === false
            ) {
                throw new Error(
                    'Unable to retrieve KyberProc authorization.'
                );
            }

            const isAuthorized =
                result?.isEnabled === true ||
                result?.IsEnabled === true;

            this.setState({
                isKyberProcAuthorized: isAuthorized,
                isKyberProcAuthorizationLoaded: true,
            });

            return isAuthorized;
        } catch (error) {
            console.error(
                'KyberProc authorization check failed:',
                error
            );

            this.setState({
                isKyberProcAuthorized: false,
                isKyberProcAuthorizationLoaded: true,
            });

            return false;
        }
    };

    canUseKyberProcAskAi = () =>
        this.state.isKyberProcAuthorizationLoaded === true &&
        this.state.isKyberProcAuthorized === true;

    render() {

        const {
            // component props
            onClickCancel
            , prevAction
            , nextAction
            // form
            , wirelessPortInSubscriptionFormA
            , forms
            // reducer action
            , onVendorSelect
            , onPlanSelect
            , onServiceTypeSelect
            , onCircuitTypeSelect
            , loadingSubscriptionForm

            , loadMoreVendor
            , handleVendorSearch
            , handleCircuitTypeSearch
            , loadMoreCircuitType
            , handleMobServiceTypeSearch
            , loadMoreMobServiceType
            , handlePlanTypeSearch
            , loadMorePlanType

        } = this.props;

        const { planOptions
            , vendorDetails
            , circuitTypeOptions
            , mobileServiceTypeOptions
            , vendorOptions
            , plansDatatable
            , totalOrderCost

            , isVendorLoading
            , hasMoreVendor

            , isCircuitTypeLoading
            , hasMoreCircuitType

            , isMobServiceTypeLoading
            , hasMoreMobServiceType

            , isPlanTypeLoading
            , hasMorePlanType
        } = this.props.wirelessPortInRequest;

        let disableSubmit = (!wirelessPortInSubscriptionFormA.personalMobile || !forms.wirelessPortInSubscriptionFormA.personalMobile.valid)
            || !wirelessPortInSubscriptionFormA.currentVendor
            || !wirelessPortInSubscriptionFormA.vendorDetailId
            || !wirelessPortInSubscriptionFormA.planId
            || !wirelessPortInSubscriptionFormA.circuitTypeId
            || !wirelessPortInSubscriptionFormA.equipmentInventoryId;

        const orderId = this.props.match.params.orderId;

        const totalCost = wirelessPortInSubscriptionFormA.planId ? totalOrderCost : 0;

        const formattedTotalComponentCost = parseFloat(totalCost).toFixed(2);

        return loadingSubscriptionForm ?
            <Loading /> :
            (
                <div className="portin-subscription-container">
                    <Row>
                        <Col className={`${forms.wirelessPortInSubscriptionFormA.personalMobile.valid ? "margin-bottom-20" : "mb-1"}`} xs={12} md={12} lg={12}>
                            <InputFieldFloatingLabel
                                className="form-control required"
                                type="text"
                                label={`${this.toLocaleLanguage('personal_mobile_number')}`}
                                value={wirelessPortInSubscriptionFormA.personalMobile}
                                onBlurAction={(model, value) => this.props.validateMobileNumber(model, value, this.props.match.params.orderId)}
                                fieldProp='wirelessPortInSubscriptionFormA.personalMobile'
                                placeholder={"Enter text here..."}
                                maxLength={MAX_LENGTH.limit_100}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="margin-bottom-20" xs={12} md={12} lg={12}>
                            <InputFieldFloatingLabel
                                className="form-control required"
                                type="text"
                                label={`${this.toLocaleLanguage('current_vendor')}`}
                                value={wirelessPortInSubscriptionFormA.currentVendor}
                                fieldProp='wirelessPortInSubscriptionFormA.currentVendor'
                                placeholder={"Enter text here..."}
                                maxLength={MAX_LENGTH.limit_100}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="margin-bottom-20" xs={12} md={12} lg={12}>
                            <InputFieldFloatingLabel
                                className="form-control"
                                type="text"
                                label={`${this.toLocaleLanguage('account_number')}`}
                                value={wirelessPortInSubscriptionFormA.accountNumber}
                                fieldProp='wirelessPortInSubscriptionFormA.accountNumber'
                                placeholder={"Enter text here..."}
                                maxLength={MAX_LENGTH.limit_100}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="margin-bottom-20" xs={12} md={12} lg={12}>
                            <InputFieldFloatingLabel
                                className="form-control"
                                type="text"
                                label={this.toLocaleLanguage('porting_pin_code')}
                                value={wirelessPortInSubscriptionFormA.portPinCode}
                                fieldProp='wirelessPortInSubscriptionFormA.portPinCode'
                                placeholder={"Enter text here..."}
                                maxLength={MAX_LENGTH.limit_100}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="margin-bottom-20" xs={12} md={12} lg={12}>
                            <InputFieldFloatingLabel
                                className="form-control"
                                type="text"
                                label={`${this.toLocaleLanguage('current_billing_address')}`}
                                value={wirelessPortInSubscriptionFormA.currentBillingAddress}
                                fieldProp='wirelessPortInSubscriptionFormA.currentBillingAddress'
                                placeholder={"Enter text here..."}
                                maxLength={MAX_LENGTH.limit_500}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="required margin-bottom-20" xs={12} md={12} lg={12}>
                            <CustomSearchableDropdownWrapper
                                label={`${this.toLocaleLanguage('vendor')}`}
                                options={vendorOptions}
                                placeholder="Select..."
                                fieldProp='wirelessPortInSubscriptionFormA.vendorDetailId'
                                selected={wirelessPortInSubscriptionFormA.vendorDetailId}
                                onChange={(val) => onVendorSelect(val)}
                                optionLabelKey={{
                                    Key: 'Key',
                                    Value: 'Value'
                                }}
                                maxLength={MAX_LENGTH.limit_100}

                                onSearchChange={handleVendorSearch}
                                onLoadMore={loadMoreVendor}
                                isLoading={isVendorLoading}
                                hasMore={hasMoreVendor}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="margin-bottom-20 required" xs={12} md={12} lg={12}>
                            <CustomSearchableDropdownWrapper
                                label={`${this.toLocaleLanguage('circuit_type')}`}
                                options={circuitTypeOptions}
                                placeholder="Select..."
                                fieldProp='wirelessPortInSubscriptionFormA.circuitTypeId'
                                selected={wirelessPortInSubscriptionFormA.circuitTypeId}
                                onChange={(val) => onCircuitTypeSelect(val)}
                                optionLabelKey={{
                                    Key: 'Key',
                                    Value: 'Value'
                                }}
                                maxLength={MAX_LENGTH.limit_100}

                                onSearchChange={handleCircuitTypeSearch}
                                onLoadMore={loadMoreCircuitType}
                                isLoading={isCircuitTypeLoading}
                                hasMore={hasMoreCircuitType}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col
                            className={`required ${forms.wirelessPortInSubscriptionFormA.equipmentInventoryId.valid
                                ? "margin-bottom-20"
                                : "mb-1"
                                }`}
                            xs={12}
                            md={12}
                            lg={12}
                        >
                            <CustomSearchableDropdownWrapper
                                label={`${this.toLocaleLanguage("mobile_service_type")}`}
                                labelRight={
                                    this.canUseKyberProcAskAi() &&
                                        Number(
                                            wirelessPortInSubscriptionFormA
                                                .equipmentInventoryId || 0
                                        ) > 0 ? (
                                        <span
                                            className="ask-ai-inline"
                                            onClick={() => {
                                                const equipmentId = Number(wirelessPortInSubscriptionFormA.equipmentInventoryId || 0);
                                                const equipmentModel =
                                                    equipmentId > 0 ? this.findOptionValue(mobileServiceTypeOptions, equipmentId) : null;

                                                const planId = Number(wirelessPortInSubscriptionFormA.planId || 0);
                                                const planName = planId > 0 ? this.findOptionValue(planOptions, planId) : null;

                                                const currentOptions = Array.isArray(mobileServiceTypeOptions) ? mobileServiceTypeOptions : [];
                                                const cachedOptions = Array.isArray(this.state.cachedMobileServiceTypeOptions)
                                                    ? this.state.cachedMobileServiceTypeOptions
                                                    : [];

                                                const sourceOptions = currentOptions.length >= 2 ? currentOptions : cachedOptions;

                                                const allowedEquipmentIds = sourceOptions
                                                    .map(o => Number(o?.Key ?? 0))
                                                    .filter(n => Number.isFinite(n) && n > 0);

                                                const payload = {
                                                    entrySource: "service_type_link",
                                                    selectedEquipmentInventoryId: equipmentId,
                                                    selectedEquipmentModel: equipmentModel,
                                                    circuitTypeId: Number(wirelessPortInSubscriptionFormA.circuitTypeId || 0),
                                                    vendorId: Number(wirelessPortInSubscriptionFormA.vendorDetailId || 0),
                                                    allowedEquipmentIds,
                                                    ...(planId > 0 ? { selectedPlanId: planId, selectedPlanName: planName } : {}),
                                                };

                                                if (!allowedEquipmentIds || allowedEquipmentIds.length < 2) {
                                                    console.warn("Ask AI: allowedEquipmentIds has < 2 items. Cannot compare within selection reliably.");
                                                }

                                                this.openAskAi(payload);
                                            }}
                                        >
                                            Ask AI ✨
                                        </span>
                                    ) : null
                                }
                                options={mobileServiceTypeOptions}
                                placeholder="Select..."
                                fieldProp="wirelessPortInSubscriptionFormA.equipmentInventoryId"
                                selected={wirelessPortInSubscriptionFormA.equipmentInventoryId}
                                onChange={(val) =>
                                    onServiceTypeSelect("wirelessPortInSubscriptionFormA.equipmentInventoryId", val, orderId)
                                }
                                optionLabelKey={{ Key: "Key", Value: "Value" }}
                                maxLength={MAX_LENGTH.limit_100}
                                onSearchChange={handleMobServiceTypeSearch}
                                onLoadMore={loadMoreMobServiceType}
                                isLoading={isMobServiceTypeLoading}
                                hasMore={hasMoreMobServiceType}
                            />
                        </Col>
                    </Row>
                    {
                        wirelessPortInSubscriptionFormA.circuitTypeId == CircuitTypes.mobile_or_cellphone && wirelessPortInSubscriptionFormA.equipmentInventoryId != undefined && wirelessPortInSubscriptionFormA.equipmentInventoryId != 0 &&
                        <ControlCheckBox
                            classWrapper="custom-checkbox-wrapper"
                            label={`${this.toLocaleLanguage('include_phone_accessory')}`}
                            model="wirelessPortInSubscriptionFormA.phoneCaseAccessory"
                            checked={wirelessPortInSubscriptionFormA.phoneCaseAccessory}
                        />
                    }
                    <Row>
                        <Col className="required margin-bottom-20" xs={12} md={12} lg={12}>
                            <CustomSearchableDropdownWrapper
                                label={`${this.toLocaleLanguage('plan')}`}
                                labelRight={
                                    this.canUseKyberProcAskAi() &&
                                        Number(
                                            wirelessPortInSubscriptionFormA
                                                .planId || 0
                                        ) > 0 ? (
                                        <span
                                            className="ask-ai-inline"
                                            onClick={() => {
                                                const planId = Number(wirelessPortInSubscriptionFormA.planId || 0);
                                                const planName = this.findOptionValue(planOptions, planId);

                                                const equipmentId = Number(wirelessPortInSubscriptionFormA.equipmentInventoryId || 0);

                                                const payload = {
                                                    entrySource: "plan_link",
                                                    selectedPlanId: planId,
                                                    selectedPlanName: planName,
                                                    circuitTypeId: Number(wirelessPortInSubscriptionFormA.circuitTypeId || 0),
                                                    vendorId: Number(wirelessPortInSubscriptionFormA.vendorDetailId || 0),
                                                    selectedEquipmentInventoryId: equipmentId,
                                                    selectedEquipmentModel:
                                                        equipmentId > 0
                                                            ? this.findOptionValue(mobileServiceTypeOptions, equipmentId)
                                                            : null,
                                                };

                                                this.openAskAi(payload);
                                            }}
                                        >
                                            Ask AI ✨
                                        </span>
                                    ) : null
                                }
                                options={planOptions}
                                placeholder="Select..."
                                fieldProp="wirelessPortInSubscriptionFormA.planId"
                                selected={wirelessPortInSubscriptionFormA.planId}
                                onChange={(val) => onPlanSelect("wirelessPortInSubscriptionFormA.planId", val)}
                                optionLabelKey={{ Key: "Key", Value: "Value" }}
                                maxLength={MAX_LENGTH.limit_100}
                                onSearchChange={handlePlanTypeSearch}
                                onLoadMore={loadMorePlanType}
                                isLoading={isPlanTypeLoading}
                                hasMore={hasMorePlanType}
                            />
                        </Col>
                    </Row>

                    {wirelessPortInSubscriptionFormA.planId ?
                        <TableWithButton
                            classNameWrapper="table-details-wrapper detail-list-modal table-padding-sub"
                            datatable={plansDatatable}
                            haveExternalDeleteBtn={false}
                            haveCheckBox={true}
                        /> : null
                    }

                    <div className="price-plan-total-cost-container">
                        <div className="price-plan-header">
                            <span><Translation translationKey="total_order_cost" /></span>
                        </div>
                        <div className="price-plan-total">
                            <span>{vendorDetails.Currency}</span>
                            <span>{formattedTotalComponentCost}</span>
                        </div>
                    </div>

                    <div className="request-button-continer">
                        <div className="bottom-left">
                            <Button
                                label={this.toLocaleLanguage('modal_close_cancel_button')}
                                variant={"light"}
                                action={onClickCancel}
                                type="button"
                            />
                        </div>
                        <div className="bottom-right">
                            <div>
                                <Button
                                    label={this.toLocaleLanguage('back')}
                                    variant={"outline-secondary"}
                                    type={"button"}
                                    action={prevAction}
                                    className="btn-custom-violet-hover-outline"
                                />
                            </div>
                            <div>
                                <Button
                                    label={this.toLocaleLanguage('next_button')}
                                    variant={"primary"}
                                    type={"button"}
                                    action={nextAction}
                                    disabled={disableSubmit}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            );
    }
};


export default withRouter(
    connect(
        state => {
            const { wirelessPortInRequest, translation } = state;
            const { wirelessPortInSubscriptionFormA, forms } = state.form;
            return {
                wirelessPortInRequest
                , wirelessPortInSubscriptionFormA
                , forms
                , ...translation,
            };
        }
        , dispatch =>
            bindActionCreators(
                Object.assign({}, wirelessPortInActions, ChatbotActions),
                dispatch
            )
    )(PortInSubscriptionFormA)
);